import siteSlice, {
  SetCurrentTabIdPayload,
  SetInstalledAppsPayload,
  SetIsSocialChatPayload,
  SetIsWidgetPluginPayload,
  SetSettingsTabPayload,
} from '../slices/site-slice';

export const getSetInstalledAppsAction = (
  installedApps: SetInstalledAppsPayload['installedApps'],
) => siteSlice.actions.setInstalledApps({ installedApps });

export const getSetIsSocialChatAction = (
  isSocialChat: SetIsSocialChatPayload['isSocialChat'],
) => siteSlice.actions.setIsSocialChat({ isSocialChat });

export const getSetSettingsTabAction = (
  settingsTab: SetSettingsTabPayload['settingsTab'],
) => siteSlice.actions.setSettingsTab({ settingsTab });

export const getSetIsWidgetPluginAction = (
  isWidgetPlugin: SetIsWidgetPluginPayload['isWidgetPlugin'],
) => siteSlice.actions.setIsWidgetPlugin({ isWidgetPlugin });

export const getSetCurrentTabIdAction = (
  currentTabId: SetCurrentTabIdPayload['currentTabId'],
) => siteSlice.actions.setCurrentTabId({ currentTabId });
